import React from "react";
import {withTranslate} from "react-redux-multilingual";


const AddBlogComment = ({translate, onSubmission, errors, addingComment, handleInputChange}) => {
    return (
        <form onSubmit={onSubmission} id="add-comment-form" className="p-5 bg-light">
            <div className="form-group">
                <label htmlFor="name">{translate("name")}</label>
                <span className="red">*</span>
                <input required
                       className={errors["author"] ? "form-control red-border" : "form-control"}

                       autoComplete="new-password"
                       type="text" name="author"

                       onChange={(e) => handleInputChange(e, "author")}
                /><span
                className="form-validation">{errors["author"]}</span>
            </div>
            <div className="form-group">
                <label className="form-label-outside"
                       htmlFor="comment-email">{translate("email")}</label>
                <span className="red">*</span>
                <input
                    required
                    className={errors["email"] ? "form-control email red-border" : "form-control email"}
                    type="email" name="email"
                    onChange={(e) => handleInputChange(e, "email")}
                    autoComplete="off"
                /><span
                className="form-validation">{errors["email"]}</span>
            </div>
            <div className="form-group">
                <label className="form-label-outside"
                       htmlFor="website">{translate("website")}</label>
                <input
                    className={errors["website"] ? "form-control website red-border" : "form-control website"}
                    type="text" name="website"
                    onChange={(e) => handleInputChange(e, "website")}
                    autoComplete="off"
                /><span
                className="form-validation">{errors["website"]}</span>
            </div>
            <div className="form-group">
                <label className="form-label-outside"
                       htmlFor="comment-message">{translate("your_comment")}</label>
                <span className="red">*</span>
                <textarea
                    required
                    className={errors["content"] ? "form-control content red-border" : "form-control content"}
                    name="content"
                    cols="10" rows="10"
                    onChange={(e) => handleInputChange(e, "content")}
                    autoComplete="off"
                ></textarea>
                <span
                    className="form-validation">{errors["content"]}</span>
            </div>
            <div className="form-group">
                <button type="submit" id="submit"
                       className="btn py-3 px-4 btn-primary">{translate("post_comment")}
                    <img id="loading" style={{
                        width: "20px",
                        height: "20px",
                        float: 'right',
                        display: addingComment === false ? "none" : "block"
                    }}
                         src="/images/loading.svg" alt="loading-gif"/>
                </button>
            </div>
        </form>
    )
};


export default withTranslate(AddBlogComment);
